<template>
  <modal name="tightenModal" class="tighten-modal" :clickToClose="false" width="50%" height="95%">
    <div class="tighten-modal__wrapper">
      <h5 class="modal-title p-4 d-inline-block tighten-modal__title">Заказ №{{ this.order.id }} выполнен</h5>
      <form action="" class=" d-flex align-items-center justify-content-center flex-wrap" @submit.prevent=''>
        <div class="text-center w-100"><span class="al">— Протяжка колес!</span></div>
        <div class="w-50 text-center">
          <img src="../../../assets/img/services/ready/zamena.gif" class="my-4 w-100" alt="">
        </div>
        <div class="code w-100 text-center">
          <input v-focus type="text" data-test-id="codeDinamoKey" placeholder="Код динамо-ключа" ref="tightenCode" v-model="tightenCode" autofocus>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      tightenCode: '',
      codeEntered: false
    }
  },
  computed: {
    ...mapGetters([
      "chosenServices",
      "order",
    ]),
  },
  methods: {
    hideTightenModal() {
      this.codeEntered = true
      this.$modal.hide('tightenModal')
    },
  },
  watch: {
    // needTighten() {},
    tightenCode(newVal) {
      if (newVal === '00001254') {
        this.tightenCode = ''
        this.hideTightenModal()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .tighten-modal {
    &__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    &__title {
      position: absolute;
      top: 20px;
      left: 20px;
    }
  }
</style>
